import { createContext } from "react";
import type { IDrawerContent } from "../../features/admin/interfaces/drawer.interface";

export interface DrawerContextType {
  activeContent: IDrawerContent | null;
  setActiveContent: (content: IDrawerContent | null) => void;
  onClose: () => void;
}

export const DrawerContext = createContext<DrawerContextType | undefined>(
  undefined
);
